import styled from 'vue-styled-components'

export const Content = styled.div`
    display: block;
    width: 100%;
    height: 100%;

    span {
        cursor: pointer;
        border: 1px solid #dae2e6;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        display: block;
        position: relative;
        transition: all 0.3s;

        &.color-group {
            text-decoration: unset;
            overflow: hidden;
            position: relative;

            .color-group-left,
            .color-group-right {
                position: absolute;
                transform: rotate(30deg);
                height: 4rem;
                width: 1.8rem;
            }

            .color-group-left {
                top: -7px;
                left: -1px;
            }

            .color-group-right {
                top: 0px;
                right: -0.5px;
            }
        }

        &.simple-color {
            text-decoration: unset;
        }

        &.color-picture {
            img {
                border-radius: 50%;
            }
        }
    }
`